import {Component, OnInit} from '@angular/core';
import {Device} from "../../../signalRTracker/x-models/device";
import {GeolocationStore} from "../../store/geolocation-store";
import {ReducedDeviceLocationDto} from "../../../../models/device/reduced-device-location-dto";
import {FilterKeys} from "../../../analytics/common/utils/filter/enums/filter-keys";
import {ErrorCodes} from "../../../analytics/common/enums/states/error-codes";
import {CommonModule, DatePipe} from "@angular/common";
import {NgSelectComponent} from "@ng-select/ng-select";
import {MapComponent} from "../../components/map/map.component";
import {FormsModule} from "@angular/forms";


@Component({
  selector: 'app-map-view',
  templateUrl: './map-view.component.html',
  styleUrls: ['./map-view.component.scss'],
  imports: [
    CommonModule,
    DatePipe,
    NgSelectComponent,
    MapComponent,
    FormsModule
  ],
  providers: [GeolocationStore]
})
export class MapViewComponent implements OnInit {
  currentView: View = View.Devices;

  devices: Device[] = []
  limit = 240000
  timeInterval: number = 5 * 15 * 1000;
  startTime: number = 0;
  endTime: number = 0;
  selectedCompany: string | undefined;
  isExpanded: { [key: string]: boolean } = {};

  devicesByInterval: { [key: number]: ReducedDeviceLocationDto[] } = {};
  protected readonly FilterKeys = FilterKeys;
  protected readonly ErrorCodes = ErrorCodes;
  protected readonly ErrorAnalysis = ErrorCodes;
  protected readonly View = View;

  constructor(public geolocationStore: GeolocationStore) {
  }

  selectedCompanyChanged($event: string) {
    this.isExpanded = {};
    this.selectedCompany = $event;
    this.geolocationStore.selectCompany($event);
  }

  changeDisplayedDevice(device: ReducedDeviceLocationDto) {
    this.geolocationStore.updateDeviceList(device);
  }

  inActiveDeviceList(device: ReducedDeviceLocationDto) {
    return this.geolocationStore.inActiveDeviceList(device);
  }

  isFarFromCenter(deviceId: string): number {
    return this.geolocationStore.isDeviceFarFromCenter(deviceId);
  }

  ngOnInit() {
    setTimeout(() => {
      this.geolocationStore.updateMarkers(this.devices);
    }, 0)
  }

  centerMap(lat: number, lng: number) {
    this.geolocationStore.centerMap(lat, lng)
  }

  getSidebarDevices() {
    for (let device of this.geolocationStore.sidebarDevices) {
      if (!this.isExpanded[device.id])
        this.isExpanded[device.id] = false;
    }
    return this.geolocationStore.sidebarDevices;
  }

  isExpandedActive(deviceId: string) {
    return this.isExpanded[deviceId];
  }

  toggleIsExpanded(deviceId: string) {
    this.isExpanded[deviceId] = !this.isExpanded[deviceId];
  }

  getOrderCountFromShard(shardId: string | undefined): { count: number, start: Date, end: Date }[] {
    if (shardId == "" || shardId == undefined) {
      return []
    }
    return this.geolocationStore.cachedOrderCounts[shardId];
  }
}

export enum View {
  Devices,
  Orders
}
